  <!-- login Modal -->
  <div id="loginModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="row whiteBackground mt-3 text-center">
        <h3 class="DIN2014Regular blackText" style="font-size:19px;line-height:30px">A myHarrell's login is required to
          access this publication. Please continue.</h3>
      </div>
      <!-- 3 buttons options-->
      <div class="d-none d-md-block">
        <div class="col-md-auto mt-2" style="text-align: center;">
          <h3 class="pt-3 pb-3"><a class="DIN2014Bold blueBackground whiteText"
              style="cursor: pointer;font-size:20pt;padding:8px; text-decoration: none !important"
              (click)="LoginB4Course()">LOGIN</a>
            <a class="DIN2014Bold blueBackground whiteText"
              style="cursor: pointer; margin-left:1%;font-size:20pt;padding:8px; text-decoration: none !important"
              (click)="EnrollForMyHarrells()">CREATE AN ACCOUNT</a>
            <a class="DIN2014Bold blueBackground whiteText"
              style="cursor: pointer;margin-left:1%;font-size:20pt;padding:8px; text-decoration: none !important"
              (click)="CancelLoginModal()">CANCEL</a>
          </h3>
        </div>
      </div>

      <div class="d-block d-md-none" style="margin:auto">
        <div class="col-md-auto mt-2" style="text-align: center;">
          <h3 class="pb-3 row"><a class="DIN2014Bold blueBackground whiteText"
              style="cursor: pointer;font-size:20pt;padding:8px; text-decoration: none !important"
              (click)="LoginB4Course()">LOGIN</a>
          </h3>
          <h3 class="pb-3 row">
            <a class="DIN2014Bold blueBackground whiteText"
              style="cursor: pointer; margin-left:1%;font-size:20pt;padding:8px; text-decoration: none !important"
              (click)="EnrollForMyHarrells()">CREATE AN ACCOUNT</a>
          </h3>
          <h3 class="row">
            <a class="DIN2014Bold blueBackground whiteText"
              style="cursor: pointer;margin-left:1%;font-size:20pt;padding:8px; text-decoration: none !important"
              (click)="CancelLoginModal()">CANCEL</a>
          </h3>
        </div>
      </div>


    </div>
  </div>
  <!-- End login Modal -->